import { render } from "./FooterArrowRight.vue?vue&type=template&id=cdb2ec4a"
import script from "./FooterArrowRight.vue?vue&type=script&lang=js"
export * from "./FooterArrowRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__